import axios from "axios";
import { API_R3API_ODOO_EXECUTE_URI } from "../Context/Constants";
import { getAuthRequestContext } from "./authRequest";

/**
 * gettoken execute action — same payload as GetToken.js getAvailableTokens.
 */
export const fetchGetTokenResponse = async (email, headers) => {
  const resp = await axios.post(
    API_R3API_ODOO_EXECUTE_URI,
    {
      action: "gettoken",
      domain: process.env.REACT_APP_DOMAIN_PARAM,
      emailid: email
    },
    { headers }
  );

  return resp.data;
};

export const fetchAvailableTokenLotsForCurrentUser = async () => {
  const { email, headers } = await getAuthRequestContext();
  const data = await fetchGetTokenResponse(email, headers);
  const lotList = data?.LotList || [];

  return {
    lotList,
    totalQuantityRemaining: data?.totalquantityremaining,
    raw: data
  };
};
